<template>
  <v-row>
    <v-col md="8" offset-md="2" xl="6" offset-xl="3">
      <BaseBlock title="Situation étudiant">
        <Autocomplete
          v-model="etudiant"
          title="Recherche de l'étudiant"
          subtitle="La recherche s'effectue à partir des premières lettres du nom. Au moins 2 lettres sont requises."
          source="etudiants"
        ></Autocomplete>

        <v-row v-if="etudiant" align="center">
          <v-col cols="3" offset="1">
            <v-row>
              <v-col v-if="etudiant.uid">
                <v-icon :color="colorUnivLille">mdi-alpha-l-circle</v-icon
                >Étudiant interne
              </v-col>
              <v-col v-else>Étudiant externe </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="8"
            v-if="
              user.roles.indexOf('ROLE_SUAIO') > -1 ||
                user.roles.indexOf('ROLE_ADMIN') > -1
            "
          >
            <v-checkbox
              class="ml-5"
              v-model="etudiant.presenceEntretien"
              @click="notifierPresence"
              label="A participé à un entretien pré-candidature"
            ></v-checkbox>

            <v-checkbox
              class="ml-5"
              v-model="etudiant.presenceAtelier"
              @click="notifierAtelier"
              :label="descriptionAtelier"
            ></v-checkbox>
          </v-col>
        </v-row>

        <v-row v-if="candidatures.length > 0">
          <v-col>
            <v-data-table
              :headers="headers"
              :items="candidatures"
              :items-per-page="10"
              item-key="id"
              class="elevation-1"
              dense
            >
              <template v-slot:item.etatDemande="{ item }">
                {{ item.etatDemande.libelle }}
                <span
                  v-if="
                    item.etatDemande.id == ETAT.ACCEPTEE.code ||
                      item.etatDemande.id == ETAT.REFUSEE.code ||
                      item.etatDemande.id == ETAT.NON_VALIDE.code
                  "
                  >- {{ item.dateDecision }}</span
                >
                <span
                  v-if="
                    item.etatDemande.id == ETAT.CONFIRMEE.code ||
                      item.etatDemande.id == ETAT.DESISTEMENT.code ||
                      item.etatDemande.id == ETAT.ABANDON.code
                  "
                >
                  le {{ item.dateConfirmation }}</span
                >
                <span v-if="item.etatDemande.id == ETAT.FINALISEE.code">
                  le {{ item.dateFinalisation }}</span
                >
              </template>
              <template v-slot:item.action="{ item }">
                <router-link
                  :to="{
                    name: 'detail-candidature',
                    params: {
                      idCandidature: item.id
                    }
                  }"
                >
                  <v-icon class="mr-2" title="Visualiser la candidature"
                    >mdi-eye</v-icon
                  ></router-link
                >
                <router-link
                  :to="{
                    name: 'candidature-suaio',
                    params: {
                      idCandidature: item.id,
                      idCampus: item.idCampus
                    }
                  }"
                >
                  <v-icon
                    v-if="
                      item.etatDemande.id == ETAT.VALIDATION_SUAIO.code &&
                        user.roles.indexOf('ROLE_SUAIO') > -1 &&
                        campusOK(item.idCampus)
                    "
                    class="mr-2"
                    title="Traiter la candidature"
                    >mdi-pencil</v-icon
                  >
                </router-link>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </BaseBlock>
    </v-col>
  </v-row>
</template>
<script>
import Autocomplete from "@/components/Autocomplete";
import BaseBlock from "@/components/base/BaseBlock";
import ApiCandidatureRepository from "@/repositories/ApiCandidatureRepository";
import ApiCampusRepository from "@/repositories/ApiCampusRepository";
import ApiReferentRepository from "@/repositories/ApiReferentRepository";
import { EtatDemande } from "@/mixins/EtatDemande.js";
import { mapState } from "vuex";

export default {
  name: "RechercheEtudiant",
  components: { Autocomplete, BaseBlock },
  mixins: [EtatDemande],
  data() {
    return {
      headers: [
        {
          text: "Formation",
          align: "left",
          sortable: true,
          value: "libelleFormation"
        },
        {
          text: "Etat de la demande",
          align: "center",
          sortable: true,
          value: "etatDemande"
        },
        {
          text: "Action",
          align: "center",
          sortable: false,
          value: "action"
        }
      ],
      etudiant: null,
      candidatures: [],
      campus: [],
      colorUnivLille: "#1f8388"
    };
  },
  async created() {
    if (this.user.roles.indexOf("ROLE_SUAIO") > -1) {
      this.getCampus();
    }
  },
  methods: {
    async getCampus() {
      try {
        const campus = await ApiCampusRepository.getCampusSUAIO();
        this.campus = campus;
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    campusOK(idCampus) {
      let campus = this.campus.find(x => x.id == idCampus);
      if (campus == undefined) {
        return false;
      } else {
        return true;
      }
    },
    async getCandidaturesEtudiant() {
      try {
        const candidatures = await ApiCandidatureRepository.getCandidaturesEtudiantPourGestion(
          this.etudiant.id
        );
        this.candidatures = candidatures;
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    async notifierPresence() {
      try {
        const etudiant = await ApiReferentRepository.notifierPresence(
          this.etudiant.id
        );
        this.etudiant = etudiant;

        let non = "non";
        if (this.etudiant.presenceEntretien) {
          non = "";
        }
        this.$toast.success(
          "l'étudiant(e) a été déclaré(e) " +
            non +
            " présent(e) à un entretien pré-candidature"
        );
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    async notifierAtelier() {
      try {
        const etudiant = await ApiReferentRepository.notifierAtelier(
          this.etudiant.id
        );
        this.etudiant = etudiant;

        let non = "non";
        if (this.etudiant.presenceAtelier) {
          non = "";
        }
        this.$toast.success(
          "l'étudiant(e) a été déclaré(e) " +
            non +
            " présent(e) à un atelier pré-candidature"
        );
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    }
  },
  watch: {
    etudiant() {
      if (this.etudiant) {
        this.getCandidaturesEtudiant();
      } else {
        this.candidatures = [];
      }
    }
  },
  computed: {
    ...mapState(["user"]),
    descriptionAtelier() {
      if (this.etudiant) {
        let debut = "Atelier";
        if (this.etudiant.presenceAtelier) {
          debut = "A participé à l'atelier";
        } else if (this.etudiant.descriptionAtelier) {
          debut = "Inscrit(e) à l'atelier";
        }

        return debut + " " + this.etudiant.descriptionAtelier;
      } else {
        return "";
      }
    }
  }
};
</script>
